import React, { useContext, useEffect, useState } from "react";

import Table from "../../components/Table";
import { capitalFirst } from "../../config/functions";
import FormField from "../../components/FormField";
import { ChecklistContext } from "../../hooks/checklistContext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, Card, MenuItem } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import api from "../../app/api";
import useAlert from "../../hooks/useAlert";
import DeleteIcon from '@mui/icons-material/Delete';

const QuestionList = ({
  questions,
  setQuestions,
  setQuestion,
  setEditIndex,
  setSortOrder,
  question,
  onAddQuestiuon,
  sortOrder,
  editIndex,
  onDublicateQuestiuon,
  isForm
}) => {
  const { user } = useAuth()
  const { showAlert } = useAlert();
  const [emails, setEmails] = useState([])
  const fetchEmails = async () => {
    try {
      const response = await api.get(`/profile-email?userID=${user.role == 'company' ? user._id : user.companyID?._id}`)
      if (response.data?.status) {
        setEmails(response.data?.result)
      } else {
        showAlert(response.data.message, 'danger')
      }
    } catch (error) {
      showAlert(error.message, 'danger')
    }
  }
  const labels = ["#", "Question", "Question Type", "Required", "Actions"];
  const { questionTypes, fetchQuestionTypes } = useContext(ChecklistContext);
  const [dubIndex, setDubIndex] = useState(null);
  const onChange = (question, required) => {
    setQuestions(
      questions?.map((item) =>
        item.question == question.question ? { ...item, required } : item
      )
    );
  };
  const onDelete = (question) => {
    setQuestions(
      questions?.filter((item) => item.question != question.question)
    );
  };
  const onEdit = (question, index) => {
    setQuestion(question);
    setEditIndex(index);
    setSortOrder(index + 1);
  };
  const optionFields = question.options?.map((item, index) => ({
    value: item,
    setValue: (value) => {
      const options = [...question.options];
      options[index] = value;
      setQuestion({ ...question, options });
    },
    type: "text",
    id: "riskAssesmentOptions",
  }));
  const data = questions?.map((question, index) => {
    return {
      data: question,
      fields: [
        index + 1,
        question.question,
        capitalFirst(question.type),
        (question.type != 'statement' && question.type != 'statement/Instruction') && <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDefault"
            checked={question?.required}
            onChange={(e) => onChange(question, !question.required)}
          />
        </div>,
        <div className="d-flex gap-2">
          <Box sx={{ position: "relative" }}>
            {dubIndex != null && dubIndex == index && (
              <Card
                sx={{
                  position: "absolute",
                  top: "30px",
                  left: "0",
                  backgroundColor: "white",
                  zIndex: "99",
                }}
              >
                <MenuItem
                  onClick={() => {
                    onDublicateQuestiuon(
                      {
                        question: question.question,
                        required: question.required,
                        type: question.type,
                        options: question.options
                      },
                      index
                    );
                    setDubIndex(null);
                  }}
                >
                  Under
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    onDublicateQuestiuon({
                      question: question.question,
                      required: question.required,
                      type: question.type,
                      options: question.options
                    });
                    setDubIndex(null);
                  }}
                >
                  End
                </MenuItem>
              </Card>
            )}
            <ContentCopyIcon
              // className="bi bi-pencil-square text-primary"
              onClick={() => {
                setDubIndex(
                  dubIndex == null || dubIndex != index ? index : null
                );
              }}
              style={{
                cursor: "pointer",
                height: "20px",
                width: "20px",
                color: "green",
              }}
            ></ContentCopyIcon>
          </Box>
          <i
            className="bi bi-pencil-square text-primary"
            onClick={() => onEdit(question, index)}
            style={{ cursor: "pointer" }}
          ></i>
          <i
            onClick={() => onDelete(question)}
            className="bi bi-trash3 text-danger"
            style={{ cursor: "pointer" }}
          ></i>
        </div>,
      ],
    };
  });

  useEffect(() => {
    fetchEmails()
    fetchQuestionTypes()
    setQuestion({
      question: "",
      type: "",
      hintText: "",
      options: [],
      yes: "",
      no: "",
      required: false,
    })
    return () => {
    }
  }, [])

  return (
    <Table
      title={isForm ? "Form Questions" : "Checklist Questions"}
      labels={labels}
      editIndex={editIndex}
      data={[
        ...data,
        {
          noDrag: true,
          fields: [
            "-",
            <>
              <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row' }}>
                <FormField
                  item={{
                    // label: question.type == "statement" ? "Text" : "Question",
                    value: question.question,
                    setValue: (value) =>
                      setQuestion({ ...question, question: value.slice(-1) != '\\' ? value : value.slice(0, -1) }),
                    type: "text",
                    id: "riskAssesmentTitle",
                  }}
                />
                {question.type == 'Smart Threshold' && <FormField
                  item={{
                    placeholder: "Select email",
                    value: question?.emails?.[0] || "",
                    setValue: (value) => {
                      setQuestion({ ...question, emails: [value] })
                      console.log(question)
                    },
                    type: "dropdown",
                    id: "emails",
                    options: emails,
                  }}
                />}
              </Box>
              {question.type != "options" &&
                question.type != "Check Box" ? null : (
                <div>
                  <h5 className="card-title">Options</h5>
                  <div className="gap-2 d-flex flex-column mb-2">
                    {optionFields?.map((item, index) => (
                      <div
                        className="d-flex gap-2 align-items-center"
                        key={index}
                      >
                        <i className="text-primary bi bi-record-circle"></i>
                        <FormField key={index} item={item} />
                        <i
                          onClick={() => {
                            const options = question.options?.filter(
                              (item, idx) => idx != index
                            );
                            setQuestion({ ...question, options });
                          }}
                          className="bi bi-trash text-danger"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </div>
                    ))}
                  </div>
                  <span
                    onClick={() => {
                      const options = question.options
                        ? [...question.options]
                        : [];
                      options.push("");
                      setQuestion({ ...question, options });
                    }}
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                  >
                    + Add More
                  </span>
                </div>
              )}
              {question.type != "Smart Threshold" ? null : (
                <div>
                  <h5 className="card-title">Threshold Options</h5>
                  <div className="gap-2 d-flex flex-column mb-2">
                    {question.threshold?.map((item, index) => (
                      <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row' }} key={index}>
                        <FormField
                          item={{
                            placeholder: "Threshold value",
                            value: question.threshold[index]?.value,
                            setValue: (value) =>
                              setQuestion({ ...question, threshold: question.threshold.map((item, idx) => idx === index ? { ...item, value } : item) }),
                            type: "number",
                            id: "lessThen",
                          }}
                        />
                        <FormField
                          item={{
                            placeholder: "Select operator",
                            value: question.threshold[index]?.operator,
                            setValue: (value) => {
                              setQuestion({ ...question, threshold: question.threshold.map((item, idx) => idx === index ? { ...item, operator: value } : item) })
                            },
                            type: "dropdown",
                            id: "operator",
                            options: [
                              "Greater than",
                              "Less than",
                              "Greater than or equal to",
                              "Less than or equal to",
                              "Not equal to"
                            ],
                          }}
                        />
                        <DeleteIcon sx={{
                          marginTop: '6px',
                          color: 'red',
                          cursor: 'pointer',
                        }} onClick={() => {
                          setQuestion({ ...question, threshold: question?.threshold?.filter((item, idx) => idx != index) || [] })
                        }} />
                      </Box>
                    ))}

                  </div>
                  <span
                    onClick={() => {
                      const options = question.threshold ? [...question.threshold]
                        : [];

                      options.push("");
                      setQuestion({ ...question, threshold: [...(question.threshold || []), { value: "", operator: "" }] });
                    }}
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                  >
                    + Add More
                  </span>
                </div>
              )}
            </>,
            <FormField
              item={{
                // label: "Question Type",
                value: question.type,
                setValue: (value) => {
                  setQuestion({ ...question, type: value })
                  if (value == "Smart Threshold") {
                    let questionFound = questions?.find(item => item.type == "Smart Threshold")
                    if (questionFound && questionFound?.emails?.length > 0) {
                      setQuestion(prevState => ({ ...prevState, emails: questionFound.emails || [] }))
                    }
                  }
                },
                type: "dropdown",
                options: questionTypes,
                placeholder: "Select question type",
              }}
            />,
            (question.type != 'statement' && question.type != 'statement/Instruction') && <FormField
              item={{
                value: question.required,
                setValue: (value) =>
                  setQuestion({ ...question, required: value }),
                type: "boolean",
              }}
            />,
            <button
              onClick={(e) => {
                onAddQuestiuon(
                  e,
                  sortOrder,
                  setSortOrder,
                  editIndex,
                  setEditIndex
                );
              }}
              className="btn btn-primary"
            >
              {editIndex || editIndex == 0 ? "Update" : "Add"}
            </button>,
          ],
        },
      ]}
    />
  );
};

export default QuestionList;
